import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  const userType = localStorage.getItem('user_type'); // Get user role from localStorage

  if (loading) {
    // Optionally, display a loading spinner or placeholder
    return <div>Loading...</div>;
  }
  
  // Restrict access to Dashboard for user_type = 3
  if (userType === "3" && window.location.pathname === "/dashboard") {
    return <Navigate to="/billing" />;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;